import request from '@/utils/request'
const BASE_URL = '/Home'

export default {
  list(data) {
    return request({
      url: BASE_URL + '/List',
      method: 'post',
      data
    })
  },
  info(id) {
    return request({
      url: BASE_URL + '/Info',
      method: 'get',
      data: id
    })
  },
  save(data) {
    return request({
      url: BASE_URL + '/Save',
      method: 'post',
      data
    })
  },
  delete(data) {
    return request({
      url: BASE_URL + '/Delete',
      method: 'post',
      data
    })
  },
  DashBoard(data) {
    return request({
        url: BASE_URL + '/DashBoard',
        method: 'get',
        data
      })
  },
  refreshToken(data) {
    return request({
      url: BASE_URL + '/RefreshToken',
      method: 'post',
      data
    })
  },
  getPermission() {
    return request({
      url: BASE_URL + '/GetPermission',
      method: 'post'
    })
  },
  changePwd(data) {
    return request({
      url: BASE_URL + '/ChangePwd',
      method: 'post',
      data
    })
  },
  Logout(data) {
    return request({
      url: BASE_URL + '/Logout',
      method: 'post',
      data
    })
  },
  ForceLogout(data) {
    return request({
      url: BASE_URL + '/ForceLogout',
      method: 'post',
      data
    })
  },
}